import { render, staticRenderFns } from "./CommissionCalculationTable.vue?vue&type=template&id=0270d956&scoped=true&"
import script from "./CommissionCalculationTable.vue?vue&type=script&lang=js&"
export * from "./CommissionCalculationTable.vue?vue&type=script&lang=js&"
import style0 from "./CommissionCalculationTable.vue?vue&type=style&index=0&id=0270d956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270d956",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VTextField})
